import { render } from "./UserProducts.vue?vue&type=template&id=25118366"
import script from "./UserProducts.vue?vue&type=script&lang=js"
export * from "./UserProducts.vue?vue&type=script&lang=js"

import "./UserProducts.vue?vue&type=style&index=0&id=25118366&lang=css"

import exportComponent from "C:\\Users\\Admin\\NodeProjects\\FibreFrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__